import { Component, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslocoPipe } from '@jsverse/transloco';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalComponent } from '@zero/shared/ui-web-design-system';
import { commonRoutes } from 'constants/web-app-constants';

@Component({
  templateUrl: './no-crypto-wallet-modal.component.html',
  standalone: true,
  imports: [ModalComponent, TranslocoPipe, RouterLink],
})
export class NoCryptoWalletModalComponent {
  public readonly VERWALTUNG_URL = commonRoutes.postlogin.verwaltung;

  public readonly modal = inject(NgbActiveModal);
}
